import { render, staticRenderFns } from "./OrderStatusForm.vue?vue&type=template&id=0026826c&scoped=true&"
import script from "./OrderStatusForm.vue?vue&type=script&lang=js&"
export * from "./OrderStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusForm.vue?vue&type=style&index=0&id=0026826c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0026826c",
  null
  
)

export default component.exports